import { Observable } from 'rxjs';
import { ICredentialDto } from 'src/app/core/models/api/credential-dto';
import { INewCredentialDto } from 'src/app/core/models/api/new-credential-dto';
import { ICredentialDataFilterDto } from '../../models/api/credential-filter-dto';
import { IDeleteCredentialDto } from '../../models/api/delete-credential-dto';

export abstract class ClavesCiasContract {
  public abstract getCredentials(): Observable<Array<ICredentialDto>>;
  public abstract registerCredential(newCredentialDto: INewCredentialDto): Observable<ICredentialDto>;
  public abstract findCredentials(filter: ICredentialDataFilterDto): Observable<Array<ICredentialDto>>;
  public abstract updateCredential(credentialDto: ICredentialDto): Observable<ICredentialDto>;
  public abstract reactivateCredential(credentialId: number): Observable<boolean>;
  public abstract deleteCredential(deleteCredentialDto: IDeleteCredentialDto): Observable<ICredentialDto>;
}
